import React from "react";
import { resolve } from "styled-jsx/css";
import "react-responsive-modal/styles.css";
import { Modal as RRModal } from "react-responsive-modal";
import { OverrideGlobalStyles } from "../components/OverrideGlobalStyles";
import { useTheme } from "./theme";
import { debounce } from "../utils/debounce";

const { className: rootClassName, styles: rootStyles } = resolve`
    // Above the top bar that houses the cart
    z-index: 9001;
`;

const gutterWidth = 2;

const { className: overlayClassName, styles: overlayStyles } = resolve`
    background-color: rgba(0, 0, 0, 0.8);
`;

const { className: containerClassName, styles: containerStyles } = resolve`
    scroll-behavior: smooth;
`;

const getModalStyle = (contentWidth) => resolve`
    font-size: 16px;
    max-width: 100%;
    margin: 0;
    padding: 2em 0;
    background-color: #f0f0f0;

    @media (min-width: ${contentWidth + (1.2 + gutterWidth) * 2}em) {
        // Extra space for the repositioned close button
        padding-top: 3em;
        border-radius: 1.25em;
        width: ${contentWidth + gutterWidth * 2}em;
        margin: 1.2em;
    }
`;

const getCloseButtonStyle = ({ contentWidth, altTextColor }) => resolve`
    font-size: 1em;
    padding: 0.25em;
    height: 2.5em;
    width: 2.5em;
    top: 0.25em;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px solid transparent;
    border-radius: 4px;

    :focus,
    :hover,
    :active {
        outline: 0;
        border: 2px solid ${altTextColor};
    }

    @media (min-width: ${contentWidth + (1.2 + gutterWidth) * 2}em) {
        top: 0.75em;
        right: ${gutterWidth - 0.5}em;
    }
`;

const debounced = debounce((fn) => fn(), 200);

export function Modal({ children, onClose, ...rest }) {
    const { contentWidth, altTextColor } = useTheme();
    const { className: modalClassName, styles: modalStyles } = getModalStyle(
        contentWidth
    );
    const {
        className: closeClassName,
        styles: closeStyles,
    } = getCloseButtonStyle({ contentWidth, altTextColor });

    // For some reason, RRModal calls onClose twice every time except the first,
    // when you close with Esc key
    const close = () => debounced(onClose);

    // onAnimationEnd is fired even during open so use onClose instead for now
    return (
        <RRModal
            classNames={{
                root: rootClassName,
                modal: modalClassName,
                closeButton: closeClassName,
                overlay: overlayClassName,
                modalContainer: containerClassName,
            }}
            onClose={close}
            {...rest}
            center
        >
            <OverrideGlobalStyles>
                {children}
                {rootStyles}
                {modalStyles}
                {closeStyles}
                {overlayStyles}
                {containerStyles}
            </OverrideGlobalStyles>
        </RRModal>
    );
}
